import styled from "@emotion/styled";
import fuzzySort from "fuzzysort";
import React from "react";
import { fontWeight } from "../../../typography/constants/typographyConstants";
export const FuzzySearchResult = props => {
  const {
    optionToString,
    option,
    inputValue
  } = props;
  const optionAsString = optionToString(option);
  let optionLabel = [optionAsString];
  const result = fuzzySort.single(inputValue, optionAsString);
  if (result) {
    optionLabel = result.highlight((match, index) => /*#__PURE__*/React.createElement(FuzzySearchMatchStyled, {
      key: index
    }, match));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, optionLabel);
};
const FuzzySearchMatchStyled = styled("span")`
    font-weight: ${fontWeight.extraBold};
`;
//# sourceMappingURL=FuzzySearchResult.js.map